import { useState, useEffect, useCallback } from 'react';
import { supplierService } from '../../../../services/supplierService';
import { productService } from '../../../../services/productService';
import {
  loadStoredFilters,
  saveStoredFilters,
  buildFilterParams,
} from './shared';

export default function usePriceTrackingFilters() {
  const [filters, setFilters] = useState(loadStoredFilters);
  const [suppliers, setSuppliers] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    supplierService.getSuppliers().then((r) => {
      if (r.success && r.data) setSuppliers(r.data);
    }).catch(() => {});
    productService.getProducts({ active_only: true }).then((r) => {
      if (r.success && r.data) setProducts(r.data);
    }).catch(() => {});
  }, []);

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => {
      const next = { ...prev, [key]: value };
      saveStoredFilters(next);
      return next;
    });
  }, []);

  const buildParams = useCallback(
    (options = {}) => buildFilterParams(filters, options),
    [filters],
  );

  return {
    filters,
    setFilters: (next) => {
      const merged = { ...filters, ...next };
      saveStoredFilters(merged);
      setFilters(merged);
    },
    updateFilter,
    buildParams,
    suppliers,
    products,
  };
}
